import Image from "next/image"
import Link from "next/link"

import { generateWhatsAppLink } from "@/lib/generateWhatsappLink"

export function WhatsAppLinks() {

  return (
    <Link
      href={generateWhatsAppLink(process.env.NEXT_PUBLIC_WHATSAPP_NUMBER || '', 'Olá! Gostaria de mais informações.')}
      target="_blank"
      className="flex items-center gap-2 text-sm"
    >
      <Image
        src="/whatsapp-icon.svg"
        alt="WhatsApp Icon"
        width={20}
        height={20}
        className="h-5 w-5"
      />
      { process.env.NEXT_PUBLIC_WHATSAPP_NUMBER } <span className="font-extrabold">(Atendimento 24 Horas)</span>
    </Link>
  )
}